// extracted by mini-css-extract-plugin
module.exports = {"buyerGuaranteeBox":"styles_buyerGuaranteeBox__3_sgN","guaranteeLink":"styles_guaranteeLink__2qk1M","title":"styles_title__2L5Bn","guaranteeIcon":"styles_guaranteeIcon__2B65i"};